import { useMatch, useNavigate } from 'react-router-dom'
import Wrapper from './wrapper'


const Header = () => {
   const isHomePage = !!useMatch('')
   const navigate = useNavigate()

   return <Wrapper isHomePage={isHomePage} navigate={navigate}/>
}

export default Header
